import { ConversationResp } from 'types/api/response/conversation-resp'

import { api } from './api'

export const getConversation = (conversationId: number | string) =>
  api.get<ConversationResp>(`/conversations/${conversationId}`)
